import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { SessionService } from '../../Util/Session/session.service';
import { environment } from '../../../environments/environment';
import { map } from 'rxjs';


@Injectable({
  providedIn: 'root'
})
export class RateContractService {

  constructor(
    private http: HttpClient,
    private session: SessionService,
  ) {
    environment.API_URL = this.session.GetUserDetails().ApiUrl;
  }

  DocFillComboLoad(Detail: any) {
    return this.http.post<any>(environment.API_URL + `DocFillCombo/Load`,
      this.session.SetClass(Detail)
    ).pipe(map(response => {
      if (response.Error_Code == '11' || response.Error_Code == '02') {
        this.session.End();
      } else {
        return response;
      }
    }));
  }

  ContractRateSalaryBillingLoad(Detail: any) {
    return this.http.post<any>(environment.API_URL + `ContractRateSalaryBilling/Load`,
      this.session.SetClass(Detail)
    ).pipe(map(response => {
      if (response.Error_Code == '11' || response.Error_Code == '02') {
        this.session.End();
      } else {
        return response;
      }
    }));
  }

  LoadDefaultParamDeduction(Detail: any) {
    return this.http.post<any>(environment.API_URL + `LoadDefaultParam/Deduction`,
      this.session.SetClass(Detail)
    ).pipe(map(response => {
      if (response.Error_Code == '11' || response.Error_Code == '02') {
        this.session.End();
      } else {
        return response;
      }
    }));
  }

  SalaryHeadMasterSELECT(Detail: any) {
    return this.http.post<any>(environment.API_URL + `SalaryHeadMaster/SELECT`,
      this.session.SetClass(Detail)
    ).pipe(map(response => {
      if (response.Error_Code == '11' || response.Error_Code == '02') {
        this.session.End();
      } else {
        return response;
      }
    }));
  }

  GetSalaryHeadCodeForRateContract(Detail: any) {
    return this.http.post<any>(environment.API_URL + `GetSalaryHeadCodeForRate/Contract`,
      this.session.SetClass(Detail)
    ).pipe(map(response => {
      if (response.Error_Code == '11' || response.Error_Code == '02') {
        this.session.End();
      } else {
        return response;
      }
    }));
  }
}
